import IMask from "imask";

// Options for input number with decimal
const numberWithDecimalOptions = {
    mask: Number,
    scale: 3,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    radix: ".",
    mapToRadix: ["."],
    min: 0,
    max: 100,
};

const numberWithTwoDecimals = {
    mask: Number,
    scale: 2,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    radix: ".",
    mapToRadix: ["."],
    min: 0,
    max: 1000000,
};

const numberOnlyDigits = {
    mask: Number,
    scale: 0,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    min: 0,
    max: 1000000,
};

const numberOnlyDigitsFromOne = {
    mask: Number,
    scale: 0,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    min: 0,
    max: 1000000,
};

const numberProcent = {
    mask: Number,
    scale: 2,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    radix: ".",
    mapToRadix: ["."],
    min: 0,
    max: 100,
};

const yearInput = {
    mask: Number,
    autofix: true,
    scale: 0,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: true,
    min: 1900,
    max: new Date().getFullYear(),
};

// init mask to inputs

const inputCommision = document.querySelector("input[id=commission]"); // input name commission

if (inputCommision) {
    new IMask(inputCommision, numberProcent);
}

const inputDefaultCommision = document.querySelector(
    "input[id=default-commission]"
); // input name commission

if (inputDefaultCommision) {
    new IMask(inputDefaultCommision, numberProcent);
}

const inputHardCost = document.querySelector("input[id=hard_cost]"); // input name hard_cost

if (inputHardCost) {
    new IMask(inputHardCost, numberWithTwoDecimals);
}

const inputAmout = document.querySelector("input[id=amount]"); // input name amount

if (inputAmout) {
    new IMask(inputAmout, numberWithTwoDecimals);
}

const inputCollected = document.querySelector("input[id=collected]"); // input name collected

if (inputCollected) {
    new IMask(inputCollected, numberWithTwoDecimals);
}

const inputNumOfPayments = document.querySelector("input[id=num_of_payments]"); // input name collected

if (inputNumOfPayments) {
    new IMask(inputNumOfPayments, numberOnlyDigits);
}

const inputCap = document.querySelector("input[class=deals-form-cap]");

if (inputCap) {
    new IMask(inputCap, numberProcent);
}

const inputDefaultCap = document.querySelector("input[id=default_cap]");

if (inputDefaultCap) {
    new IMask(inputDefaultCap, numberProcent);
}

const inputYearFounded = document.querySelector("input[id=year_founded]");

if (inputYearFounded) {
    new IMask(inputYearFounded, yearInput);
}
const inputDstance = document.querySelector("input[id=distance]");

if (inputDstance) {
    new IMask(inputDstance, numberWithTwoDecimals);
}

const periodInputControl = document.getElementById("period");

if (periodInputControl) {
    new IMask(periodInputControl, numberOnlyDigitsFromOne);
}
